<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense dark>
                <v-spacer></v-spacer>
                <h3>
                    Loads By {{ $store.state.load.title }} <v-spacer></v-spacer>
                </h3>
                <v-spacer></v-spacer>
                <v-btn dark icon to="/reports/loads-by"
                    ><v-icon>mdi-arrow-left</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="4">
                        <v-row justify="end">
                            <v-col cols="12">
                                <v-text-field
                                    v-model="search"
                                    label="Search"
                                    dense
                                    style="margin-top: 0px;padding: 10px;"
                                    hide-details
                                    append-outer-icon="mdi-microsoft-excel"
                                    @click:append-outer="report()"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table
                            dense
                            :headers="headers"
                            :items="items"
                            :search="search"
                                    fixed-header
                                    height="600px"
                            disable-items-per-page
                            disable-pagination
                            class="elevation-1"
                            hide-default-footer
                            v-if="show == 1"
                        >
                            <template v-slot:item.Act="{ item }">
                                <td
                                    style="border:1px #4f83cc solid;text-align: center;"
                                    class="hover"
                                    @click="open(item)"
                                >
                                    <div v-if="item.Act == 'Active'">
                                        <v-icon color="success"
                                            >mdi-star-four-points-small</v-icon
                                        >
                                        {{ item.Act }}
                                    </div>
                                    <div v-else>
                                        <v-icon color="red"
                                            >mdi-star-four-points-small</v-icon
                                        >
                                        {{ item.Act }}
                                    </div>
                                </td>
                            </template>
                        </v-data-table>
                        <v-container style="height: 400px;" v-else>
                            <v-row
                                class="fill-height"
                                align-content="center"
                                justify="center"
                            >
                                <v-col
                                    class="text-subtitle-1 text-center"
                                    cols="12"
                                >
                                    Getting your files
                                </v-col>
                                <v-col cols="6">
                                    <v-progress-linear
                                        color="primary accent-4"
                                        indeterminate
                                        rounded
                                        height="6"
                                    ></v-progress-linear>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    data: function() {
        return {
            items: [],
            headers: [],
            search: '',
            colspan: 0,
            show: 0,
            drillDown: '',
            Revenue: 0,
            OtherRev: 0,
            Expenses: 0,
            OtherExp: 0,
            Net: 0,
            view: true
        };
    },
    mounted() {
        switch (this.$store.state.load.title) {
            case 'Driver':
                this.headers = [
                    { text: 'Date', value: 'Date', width: '8%' },
                    { text: 'Shift', value: 'Shift', width: '4%' },
                    { text: 'ShiftDetail', value: 'ShiftDetail', width: '7%' }
                ];
                this.drillDown = 'shift-load/transacting';
                break;
            case 'Truck':
                this.headers = [
                    { text: 'Truck', value: 'Truck', width: '8%' },
                    {
                        text: 'ShiftDetails',
                        value: 'ShiftDetails',
                        width: '8%'
                    },
                    { text: 'Loads', value: 'Loads', width: '8%' },
                    { text: 'Active', value: 'Act', width: '8%' }
                ];
                this.drillDown = '/reports/details/load/by';
                this.$store.state.load.subTitle = 'Loads By Truck';
                this.$store.state.load.specific = '/load-by/spesific/truck';
                break;
        }
        this.getItems();
    },
    methods: {
        getItems: function() {
            var parms = {
                StartDate: this.$store.state.load.StartTime,
                EndDate: this.$store.state.load.EndTime
            };
            console.log(parms);
            axios
                .post(this.$store.state.load.url, parms)
                .then(response => {
                    this.items = response.data;
                    console.log(this.items);
                    this.show = 1;
                })
                .catch(function(error) {
                    console.log(error);
                    this.show = 1;
                });
        },
        open: function(itm) {
            this.$store.state.load.itm = itm;
            this.$store.state.load.return = '/reports/report/load/by';
            this.$router.push(this.drillDown);
        },
        report: function() {
            var parms = {
                StartDate: this.$store.state.load.StartTime,
                EndDate: this.$store.state.load.EndTime,
                Export: true
            };
            this.$store.state.isLoading = true;
            axios
                .post(this.$store.state.load.url, parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Loads-By-Report.xlsx';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        }
    }
};
</script>
<style>
.hover:hover {
    background: #a4a9de;
}
</style>
